import { useTranslation } from 'react-i18next'

export type CollectionsSubTab = 'requests' | 'monitoring'

interface CollectionsTabBarProps {
  activeTab: CollectionsSubTab
  onTabChange: (tab: CollectionsSubTab) => void
}

export function CollectionsTabBar({
  activeTab,
  onTabChange,
}: CollectionsTabBarProps): React.ReactElement {
  const { t } = useTranslation('cases')
  const tabs: Array<{ id: CollectionsSubTab; label: string }> = [
    { id: 'requests', label: t('collections.monitoring.tabRequests') },
    { id: 'monitoring', label: t('collections.monitoring.tabMonitoring') },
  ]
  return (
    <div className="flex gap-1 border-b border-[var(--border)]">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => {
            onTabChange(tab.id)
          }}
          className={`px-4 py-2 text-sm font-[var(--font-mono)] font-medium tracking-wider uppercase transition-colors ${
            activeTab === tab.id
              ? 'border-b-2 border-[var(--accent)] bg-[var(--accent-dim)] text-[var(--accent)]'
              : 'text-[var(--text-muted)] hover:text-[var(--text-primary)]'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
